import { Action as A, formatter as f } from '../../../shortcuts';
import { VERSION } from '../../../version';
/**
 * Use this extension if you need to handle form actions like cancel and/or submit.
 */
export const EditorModeKeymap = (builder, opts) => {
    var _a;
    builder.addKeymap(() => {
        const bindings = {};
        const { onCancel, onSubmit } = opts;
        if (onCancel)
            bindings[f.toPM(A.Cancel)] = () => onCancel();
        if (onSubmit)
            bindings[f.toPM(A.Submit)] = () => onSubmit();
        bindings[f.toPM(A.__debug)] = () => {
            debug();
            return true;
        };
        return bindings;
    });
    if ((_a = opts.ignoreKeysList) === null || _a === void 0 ? void 0 : _a.length) {
        const ignore = () => true;
        const bindings = {};
        for (const key of opts.ignoreKeysList) {
            bindings[key] = ignore;
        }
        builder.addKeymap(() => bindings, builder.Priority.Lowest);
    }
};
function debug() {
    const message = ['YFM-Editor Debug info', `Version: ${VERSION}`].join('\n');
    console.info(message);
}
